<template>
<div>
    <b-navbar class="bar-nav" fixed="top" type="dark" >

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-navbar-brand><router-link to="/open" class="brand"><b-img class="logo" :src="logo" fluid></b-img></router-link></b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">

            <!-- Right aligned nav items -->
            <b-nav class="ml-auto">
            <!-- <b-nav-text id="user-name" v-if="isLoggedIn">{{ this.userName }}</b-nav-text> -->

            <b-nav-item v-if="!isLoggedIn"><router-link class="link" to="/login">Login</router-link></b-nav-item>
            <b-nav-item class="user-link" v-if="isLoggedIn"><b-btn class="link user-link" @click="adminReq = true" >Admin Access</b-btn></b-nav-item>
            <b-nav-item v-if="isLoggedIn"><b-btn class="logout" @click="signOut" size="sm">Logout</b-btn></b-nav-item>
            </b-nav>

            <alert-dialog v-if="adminReq == true" class="alert-dialog" message="Enter your Admin PIN to Proceed">
              <b-btn class="cancel-update" @click="adminReq = false">X</b-btn>
              <div class="mt-5" slot="formInput">
                <b-row class="form-row" align-h="center" align-v="center">
                    <b-col cols="4" sm="3">
                        <label for="pin">PIN</label>
                    </b-col>
                    <b-col cols="8" sm="9">
                        <b-form-input id="pin" type="text" :state="pinState" v-model="pin"></b-form-input>
                        <b-form-invalid-feedback class="left-align-text" id="input-live-feedback">
                        Enter 4 numbers
                        </b-form-invalid-feedback>
                    </b-col>
                </b-row>
                <b-row align-h="center" align-v="center">
                  <b-link class="pt-2" @click="changePin = true; adminReq = false;">Forgot your PIN?</b-link>
                </b-row>
              </div>
              <p class="red" slot="errorMsg"> {{ errorMsg }}</p>
              <b-btn :disabled="!pinState" class="submit-btn" slot="successBtn" @click="checkPin">Proceed</b-btn>
              <b-btn class="cancel-btn" slot="cancelBtn" @click="adminReq = false">Cancel</b-btn>
          </alert-dialog>

          <alert-dialog v-if="changePin == true" class="alert-dialog" message="Your current PIN will be removed and we will email you a temporary PIN.">
              <b-btn class="cancel-update" @click="changePin = false">X</b-btn>
              <p class="red" slot="errorMsg"> {{ errorMsg }}</p>
              <b-btn class="submit-btn" slot="successBtn" @click="sendTempPin">Send New PIN</b-btn>
              <b-btn class="cancel-btn" slot="cancelBtn" @click="changePin = false">Cancel</b-btn>
          </alert-dialog>

          <alert-dialog v-if="textsFinished == true" class="alert-dialog" message="">
              <b-btn class="cancel-update" @click="textsFinished = false">X</b-btn>
              <div slot="formInput">
                <h3 class="red">You have sent all your Ready Messages.</h3>
                <p class="mt-3">Go to the Admin section and upgrade your plan to keep texting.</p>
                <p class="mt-3">Or wait until the end of the payment period.</p>
              </div>
          </alert-dialog>


          <div class="loader" v-if="isLoading">
            <Loader />
          </div>

        </b-collapse>
    </b-navbar>
</div>
</template>

<script>
import firebase from 'firebase'
import { db } from '../main'
import axios from 'axios'
import AlertDialog from "../components/alert-dialog/AlertDialog"
import Loader from "../components/Loader"
export default {
  components: {
    AlertDialog,
    Loader
  },
  name: 'Navbar',
  data () {
    return {
      isLoggedIn: false,
      currentUser: false,
      userName: 'User',
      logo: require('@/../src/assets/readymsg-logo.png'),
    //   signoutIcon: require('@/../src/assets/log-out-icon.png'),
      adminReq: false,
      changePin: false,
      pin: '',
      checkPinApi: 'https://us-central1-readytextme.cloudfunctions.net/checkAdminCode',
      changePinApi: 'https://us-central1-readytextme.cloudfunctions.net/forgotAdminCode',
      isLoading: false,
      errorMsg: '',
      textsFinished: false
    }
  },
  async created () {
    if (firebase.auth().currentUser) {
      const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async (doc) => {
        this.userName = doc.data().business;
        this.isLoggedIn = true
        this.currentUser = firebase.auth().currentUser.email
        const textsFinishedBool = doc.data().planTextsFinished;

        if (textsFinishedBool == 1) {
          this.textsFinished = true;
        } else {
          this.textsFinished = false;
        }
        // this.userName = firebase.auth().currentUser.displayName
      });

    }
  },
  methods: {
    signOut: function () {
      firebase.auth()
        .signOut()
        .then(() => {
          this.isLoggedIn = false
          this.$router.replace('/login')
        })
    },

    async checkPin () {
      this.isLoading = true;
      var postContent = {
        'userId': firebase.auth().currentUser.uid,
        'code': this.pin,
      }

      try {
        await axios.post(
        this.checkPinApi,
        postContent,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.isLoading = false;
        this.adminReq = false;
        this.errorMsg = "";
        this.$router.push({path: '/settings'});
        this.pin = "";
      } catch (error) {
        console.log(error);
        this.errorMsg = 'Pin does not match. Please try again.';
        this.isLoading = false;
        // this.adminReq = false;
      }
    },

    async sendTempPin () {
      this.isLoading = true;
      var postContent = {
        'userId': firebase.auth().currentUser.uid
      }

      try {
        await axios.post(
        this.changePinApi,
        postContent,
        {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        this.isLoading = false;
        this.changePin = false;
        this.errorMsg = "";
        // this.$router.push({path: '/settings'});
      } catch (error) {
        console.log(error);
        this.errorMsg = 'Please try again.';
        this.isLoading = false;
        // this.adminReq = false;
      }
    }
  },
  computed: {
    pinState() {
      return this.pin.length > 3 && this.pin.length < 5 ? true : false;
    }
  },
}
</script>

<style scoped>
    .bar-nav {
        /* background-color: #DA2a2a; */
        background-color: #ffffff;
        border-bottom: 0.3px solid #efefef;
    }

    .link {
        /* color: #ffffff; */
        color: #646464;
        font-weight: 500;
    }

    .link:hover {
      color: #DA2a2a;
    }

    .brand {
        color: #000000;
    }

    .user-link {
      /* margin-top: 4px; */
      background-color: #ffffff00;
      border: none;
      padding: 0px;
      padding-top: 2px;
    }

    .logo {
      width: 150px;
      height: auto;
    }

    .logout {
      background-color: #DA2a2a;
      border: none;
      border-radius: 3px;
    }

    .logout:hover {
      background-color: #d68181;
      /* color: #000000; */
    }

    .alert-dialog {
      position: fixed;
      border: 1px solid #929292;
      border-radius: 0px;
      padding: 20px 20px;
      background-color: #ececec;
      width: 400px;
      z-index: 3;
      top: 30%;
      transform: translateY(-50%);
      left: 50%;
      transform: translateX(-50%);
    }

    .loader {
      position: fixed;
      width: 350px;
      height: 350px;
      z-index: 100;
      padding-top: 70px;
      /* top: 0; */
      bottom: 30%;
      left: 50%;
      transform: translateX(-50%);
      background-color: #c0c0c0;
      border-radius: 5px;
      transition: all 0.8s ease;
    }

    .red {
      color: #DA2a2a;
    }
</style>
